/**
 * WWW Application Initialization
 * Sets up core application functionality, cookies, and phone number tracking
 */

import Cookies from 'universal-cookie';
import { mobileCheck } from '../mobileCheck';
import { contactFormInit } from '../contactFormInit';
import { app } from '../../common/application';
import wwwAppInit from '../application';

export const cookies = new Cookies();

// Expose utilities globally
window.mobileCheck = mobileCheck;
window.contactFormInit = contactFormInit;
window.isMobile = mobileCheck();

/**
 * Initialize core application components
 */
export function initApp() {
  // Setup common app functionality
  app.setupTooltips();
  app.setupCheckAll();
  app.setupUIBlocker();
  app.setupAjaxForms();
  app.setupObservers();
}

/**
 * Initialize WWW-specific functionality
 * Called after DOM is ready
 */
export function initWww() {
  // Initialize legacy jQuery handlers (modal-sidebar, btn-loading, etc.)
  wwwAppInit();
  
  // Handle CallRail phone number swap from cookie
  initPhoneTracking();
}

/**
 * Handle Google Analytics phone number tracking
 * Swaps phone numbers based on ga_phone cookie set by CallRail
 */
function initPhoneTracking() {
  const gaPhone = cookies.get('ga_phone');
  if (!gaPhone) return;

  const formattedNumber = app.formatPhoneNumber(gaPhone);
  if (formattedNumber) {
    const gaPhoneLink = `tel:+${gaPhone}`;
    
    // Update all click-to-call links
    document.querySelectorAll('.wy-click-to-call').forEach(el => {
      el.href = gaPhoneLink;
    });
    
    // Update phone text links
    document.querySelectorAll('.wy-click-to-call.phone-text-link').forEach(el => {
      el.textContent = formattedNumber;
    });
  } else {
    console.error('ga_phone cookie contains an invalid phone number.', gaPhone);
    window.ErrorReporter?.critical('ga_phone cookie contains an invalid phone number.', gaPhone);
  }
}

export { app, mobileCheck, contactFormInit };
